type AsyncType<T extends string> = {
  [key in T]: {
    START: string;
    SUCCESS: string;
    ERROR: string;
    FAILED_SILENTLY: string; // Bypasses default error handling in notificationsMiddleware
  };
};

const asyncTypes = <T extends string>(typeName: T, prefix: string | null = null): AsyncType<T> => {
  const name = prefix ? prefix + '_' + typeName : typeName;

  return {
    [typeName]: {
      START: `${name}_START`,
      SUCCESS: `${name}_SUCCESS`,
      ERROR: `${name}_ERROR`,
      FAILED_SILENTLY: `${name}_FAILED_SILENTLY`
    }
  } as AsyncType<T>;
};

export default asyncTypes;
